export default {"src":"/_next/static/media/ra-arrival.fc5649b8.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};